import { render, staticRenderFns } from "./edit-photo-card.vue?vue&type=template&id=49f8a861"
import script from "./edit-photo-card.vue?vue&type=script&lang=js"
export * from "./edit-photo-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports